var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-menu",
    {
      attrs: { "offset-y": "", "allow-overflow": "" },
      scopedSlots: _vm._u([
        {
          key: "activator",
          fn: function(ref) {
            var on = ref.on
            return [
              _c(
                "v-btn",
                _vm._g(
                  {
                    staticClass: "ma-0 pa-1",
                    attrs: { icon: "", text: "", "x-small": "", color: "white" }
                  },
                  on
                ),
                [
                  _c("v-icon", { attrs: { size: "15" } }, [_vm._v("more_vert")])
                ],
                1
              )
            ]
          }
        }
      ])
    },
    [
      _vm._v(" "),
      _c(
        "v-list",
        { staticClass: "pa-0", attrs: { dense: "" } },
        _vm._l(_vm.menuItems, function(item, index) {
          return item.visible
            ? _c(
                "v-list-item",
                { key: index, on: { click: item.action } },
                [
                  _c(
                    "v-list-item-avatar",
                    { staticClass: "mb-0 mt-0" },
                    [_c("v-icon", [_vm._v(_vm._s(item.icon))])],
                    1
                  ),
                  _vm._v(" "),
                  _c("v-list-item-title", [_vm._v(_vm._s(item.label))])
                ],
                1
              )
            : _vm._e()
        }),
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-04586b46", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-04586b46","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home/Forms/_Atoms/FormOptionsMenu.vue
// module id = null
// module chunks = 